import SelectTreeDetail from '../select-tree'
import AutocompleteDetail from './autocomplete'
import CascaderDetail from './cascader'
import CascaderPanelDetail from './cascader-panel'
import CheckBoxDetail from './check-box'
import ColorPickerDetail from './color-picker'
import CustomDetail from '../custom'
import DatePickerDetail from './date-picker'
import DateTimePickerDetail from './date-time-picker'
import InputNumberDetail from './input-number'
import InputDetail from './input'
import RadioDetail from './radio'
import RateDetail from './rate'
import SelectDetail from './select'
import SliderDetail from './slider'
import SuperCustomDetail from '../super-custom'
import SwitchDetail from './switch'
import TimePickerDetail from './time-picker'
import TimeSelectrDetail from './time-select'
import TransferDetail from '../transfer'
import TreeDetail from '../tree'
import UploadDetail from '../upload'

export {
  SelectTreeDetail,
  AutocompleteDetail,
  CascaderDetail,
  CascaderPanelDetail,
  CheckBoxDetail,
  ColorPickerDetail,
  CustomDetail,
  DatePickerDetail,
  DateTimePickerDetail,
  InputNumberDetail,
  InputDetail,
  RadioDetail,
  RateDetail,
  SelectDetail,
  SliderDetail,
  SuperCustomDetail,
  SwitchDetail,
  TimePickerDetail,
  TimeSelectrDetail,
  TransferDetail,
  TreeDetail,
  UploadDetail,
}
